import React, { createContext, useContext, useState, useEffect } from "react";

type Language = "no" | "en";

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string, params?: Record<string, string | number>) => string;
}

const translations = {
  no: {
    "tournament.title": "Padel Sosial Turnering",
    "tournament.date": "Dato:",
    "tournament.time": "Klokkeslett:",
    "tournament.location": "Sted:",
    "tournament.courts": "Bane:",
    "tournament.level": "Nivå:",
    "tournament.level.all": "Alle nivåer",
    "tournament.courts.numbers": "2, 3 og 4",
    "tournament.spots": "ledige plasser av totalt",
    "tournament.participants": "Påmeldte deltagere:",
    "tournament.fetching": "Henter deltakerinformasjon... Er du",
    "tournament.logged_in": "innlogget",
    "tournament.welcome": "Velkommen",
    "tournament.deadline": "Frist for avmelding",
    "tournament.24hours": " kl. 15:00 (24 timer før start)",
    "tournament.confirmed": "Gratulerer! Du har sikret deg på turneringen. Vi sees på {day}!",  
    "tournament.waitlist.info": "Dette arrangementet er fullt, men du kan melde deg på venteliste. Hvis en plass blir ledig, vil du bli varslet på e-post.",
    "tournament.waitlist.position": "Du blir nummer",
    "tournament.waitlist.onList": "på ventelisten",
    "tournament.waitlist.button": "Stå på venteliste",
    "tournament.waitlist.joined": "Du står på ventelisten. Hvis en plass blir ledig, vil du bli varslet på e-post.",
    "tournament.waitlist.signup.success": "Du er nå på venteliste, posisjon #{position}. Hvis en plass blir ledig, vil du bli varslet!",
    "tournament.registration.opens": "Påmelding åpnes for alle medlemmer om",
    "tournament.registration.timeUnits": "dag,timer,minutter",
    "tournament.back": "Tilbake til NTNUi Tennis",
    "map": "Kart",
    "tournament.success": "✅ Vellykket",
    "tournament.signup.button": "Meld deg på",
    "tournament.signup.success": "Påmelding vellykket",
    "tournament.signup.waitlist": "Du er nå på venteliste!",
    "tournament.signup.registered": "Du er nå påmeldt",
    "tournament.signup.error": "Kunne ikke melde deg på",
    "tournament.cancel.button": "Fjern påmelding",
    "tournament.cancel.confirm": "Er du sikker på at du vil melde deg av?",
    "tournament.cancel.success": "Avmeldt",
    "tournament.cancel.success.message": "Du er nå fjernet fra turneringen.",
    "tournament.cancel.waitlist.success": "Du er fjernet fra ventelisten.",
    "tournament.cancel.error": "Kunne ikke fjerne deg fra turneringen.",
    "tournament.waitlist.count": "personer på venteliste",
    "tournament.format.americano": "Americano",
    "tournament.format.mexicano": "Mexicano",
    "tournament.format.winner_court": "Vinner-Bane med Splitt",
    "tournament.format.winner_court_team": "Team Vinner-Bane",
    "tournament.format.team_americano": "Team Americano",
    "tournament.mexicano.start": "Start Mexicano Turnering",
    "tournament.mexicano.started": "Mexicano turnering har startet!",
    "tournament.mexicano.round": "Runde {round}",
    "tournament.mexicano.next_round": "Starter runde {round}",
    "tournament.mexicano.court": "Bane {number}",
    "tournament.mexicano.team": "Lag",
    "tournament.mexicano.vs": "vs",
    "tournament.mexicano.score": "Poeng",
    "tournament.mexicano.submit_results": "Lagre resultater",
    "tournament.mexicano.incomplete_results": "Vennligst fyll inn resultater for alle baner",
    "tournament.mexicano.invalid_scores": "Ugyldig score: Vinnerlaget må ha høyere score enn taperlaget og score kan ikke være mer enn 24",
    "tournament.mexicano.finished": "Turneringen er ferdig!",
    "tournament.mexicano.leaderboard": "Resultattavle",
    "tournament.mexicano.player": "Spiller",
    "tournament.mexicano.points": "Poeng",
    "tournament.mexicano.matches": "Kamper",
    "tournament.mexicano.reset": "Turneringen er nullstilt",
    "tournament.mexicano.show_leaderboard": "Vis resultattavle",
    "tournament.mexicano.hide_leaderboard": "Skjul resultattavle",
    "tournament.mexicano.winner_team": "Vinner lag",
    "tournament.mexicano.court_assignments": "Baneinndeling",
    "tournament.mexicano.enter_results": "Registrer resultater",
    "tournament.mexicano.won": "vant",
    "tournament.mexicano.select_left_team_score": "Velg poeng for venstre lag",
    "tournament.mexicano.tie": "Uavgjort",
    
    // Americano translations
    "tournament.americano.start": "Start Americano Turnering",
    "tournament.americano.started": "Americano turnering har startet!",
    "tournament.americano.round": "Runde {round}",
    "tournament.americano.court": "Bane {number}",
    "tournament.americano.team": "Lag",
    "tournament.americano.vs": "vs",
    "tournament.americano.start_round": "Start runde {round}",
    "tournament.americano.finish_round": "Fullfør runde",
    "tournament.americano.leaderboard": "Resultattavle",
    "tournament.americano.player": "Spiller",
    "tournament.americano.points": "Poeng",
    "tournament.americano.games_played": "Kamper spilt",
    "tournament.americano.partners": "Ulike partnere",
    "tournament.americano.position": "Posisjon",
    "tournament.americano.description": "Spillere bytter partner hver runde for variasjon og balanse",
    "tournament.americano.submit_results": "Lagre resultater",
    "tournament.americano.enter_score": "Registrer resultat",
    
    // Team Americano translations  
    "tournament.team_americano.start": "Start Team Americano Turnering",
    "tournament.team_americano.started": "Team Americano turnering har startet!",
    "tournament.team_americano.round": "Runde {round}",
    "tournament.team_americano.court": "Bane {number}",
    "tournament.team_americano.team": "Lag",
    "tournament.team_americano.vs": "vs",
    "tournament.team_americano.start_round": "Start runde {round}",
    "tournament.team_americano.finish_round": "Fullfør runde",
    "tournament.team_americano.leaderboard": "Resultattavle",
    "tournament.team_americano.team_name": "Lag",
    "tournament.team_americano.points": "Poeng",
    "tournament.team_americano.matches_played": "Kamper spilt",
    "tournament.team_americano.position": "Posisjon",
    "tournament.team_americano.description": "Lag forblir sammen gjennom hele turneringen",
    "tournament.team_americano.submit_results": "Lagre resultater",
    "tournament.team_americano.enter_score": "Registrer resultat",
  },
  en: {
    "tournament.title": "Padel Social Tournament",
    "tournament.date": "Date:",
    "tournament.time": "Time:",
    "tournament.location": "Location:",
    "tournament.courts": "Courts:",
    "tournament.level": "Level:",
    "tournament.level.all": "All levels",
    "tournament.courts.numbers": "2, 3 and 4",
    "tournament.spots": "spots available out of",
    "tournament.participants": "Registered participants:",
    "tournament.fetching": "Fetching participant information... Are you",
    "tournament.logged_in": "logged in",
    "tournament.welcome": "Welcome",
    "tournament.deadline": "Unregister deadline",
    "tournament.24hours": ", 3:00 PM (24 hours before the start)",
    "tournament.confirmed": "Congratulations! You have secured a spot. See you on {day}!",
    "tournament.waitlist.info": "This event is full, but you can sign up for the waiting list. If a spot becomes available, you will be notified by email.",
    "tournament.waitlist.position": "You will be number",
    "tournament.waitlist.onList": "in the waiting list",
    "tournament.waitlist.button": "Join waiting list",
    "tournament.waitlist.joined": "You are on the waiting list. If a spot becomes available, you will be notified by email.",
    "tournament.waitlist.signup.success": "You are now on the waitlist, position #{position}. If a spot opens up, you will be notified!",
    "tournament.registration.opens": "Registration opens for all members in",
    "tournament.registration.timeUnits": "day,hours,minutes",
    "tournament.back": "Back to NTNUi Tennis",
    "map": "Map",
    "tournament.success": "✅ Success",
    "tournament.signup.button": "Sign up",
    "tournament.signup.success": "Sign up successful!",
    "tournament.signup.error": "Sign up failed",
    "tournament.signup.waitlist": "You have now joined the waiting list!",
    "tournament.signup.registered": "You are now registered",
    "tournament.cancel.button": "Cancel Participation",
    "tournament.cancel.confirm": "Are you sure you want to cancel participation?",
    "tournament.cancel.success": "Unregistered",
    "tournament.cancel.success.message": "You have been removed from the tournament.",
    "tournament.cancel.waitlist.success": "You have been removed from the waitlist.",
    "tournament.cancel.error": "Could not remove you from the tournament.",
    "tournament.waitlist.count": "people in waiting list",
    "tournament.format.americano": "Americano",
    "tournament.format.mexicano": "Mexicano",
    "tournament.format.winner_court": "Winner-Court with Split",
    "tournament.format.winner_court_team": "Team Winner-Court",
    "tournament.format.team_americano": "Team Americano",
    "tournament.mexicano.start": "Start Mexicano Tournament",
    "tournament.mexicano.started": "Mexicano tournament has started!",
    "tournament.mexicano.round": "Round {round}",
    "tournament.mexicano.next_round": "Starting round {round}",
    "tournament.mexicano.court": "Court {number}",
    "tournament.mexicano.team": "Team",
    "tournament.mexicano.vs": "vs",
    "tournament.mexicano.score": "Score",
    "tournament.mexicano.submit_results": "Save Results",
    "tournament.mexicano.incomplete_results": "Please enter results for all courts",
    "tournament.mexicano.invalid_scores": "Invalid score: Winner team must have higher score than loser team and score cannot be more than 24",
    "tournament.mexicano.finished": "Tournament is finished!",
    "tournament.mexicano.leaderboard": "Leaderboard",
    "tournament.mexicano.player": "Player",
    "tournament.mexicano.points": "Points",
    "tournament.mexicano.matches": "Matches",
    "tournament.mexicano.reset": "Tournament has been reset",
    "tournament.mexicano.show_leaderboard": "Show leaderboard",
    "tournament.mexicano.hide_leaderboard": "Hide leaderboard",
    "tournament.mexicano.winner_team": "Winner team",
    "tournament.mexicano.court_assignments": "Court assignments",
    "tournament.mexicano.enter_results": "Enter results",
    "tournament.mexicano.won": "won",
    "tournament.mexicano.select_left_team_score": "Select points for left team",
    "tournament.mexicano.tie": "Tie",
    
    // Americano translations
    "tournament.americano.start": "Start Americano Tournament",
    "tournament.americano.started": "Americano tournament has started!",
    "tournament.americano.round": "Round {round}",
    "tournament.americano.court": "Court {number}",
    "tournament.americano.team": "Team",
    "tournament.americano.vs": "vs",
    "tournament.americano.start_round": "Start round {round}",
    "tournament.americano.finish_round": "Finish round",
    "tournament.americano.leaderboard": "Leaderboard",
    "tournament.americano.player": "Player",
    "tournament.americano.points": "Points",
    "tournament.americano.games_played": "Games played",
    "tournament.americano.partners": "Different partners",
    "tournament.americano.position": "Position",
    "tournament.americano.description": "Players change partners each round for variety and balance",
    "tournament.americano.submit_results": "Save results",
    "tournament.americano.enter_score": "Enter score",
    
    // Team Americano translations
    "tournament.team_americano.start": "Start Team Americano Tournament",
    "tournament.team_americano.started": "Team Americano tournament has started!",
    "tournament.team_americano.round": "Round {round}",
    "tournament.team_americano.court": "Court {number}",
    "tournament.team_americano.team": "Team",
    "tournament.team_americano.vs": "vs",
    "tournament.team_americano.start_round": "Start round {round}",
    "tournament.team_americano.finish_round": "Finish round",
    "tournament.team_americano.leaderboard": "Leaderboard",
    "tournament.team_americano.team_name": "Team",
    "tournament.team_americano.points": "Points",
    "tournament.team_americano.matches_played": "Matches played",
    "tournament.team_americano.position": "Position",
    "tournament.team_americano.description": "Teams stay together throughout the tournament",
    "tournament.team_americano.submit_results": "Save results",
    "tournament.team_americano.enter_score": "Enter score",
  },
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguage] = useState<Language>(() => {
    const savedLang = localStorage.getItem("language") as Language | null;
    if (savedLang) return savedLang;
    const browserLang = navigator.language.toLowerCase();
    return browserLang.startsWith("nb") || browserLang.startsWith("nn") || browserLang.startsWith("no")
      ? "no"
      : "en";
  });
  
  useEffect(() => {
    localStorage.setItem("language", language);
    console.log("Language updated in localStorage:", language);
  }, [language]);

  const t = (key: string, params?: Record<string, string | number>): string => {
    const translation = translations[language][key as keyof typeof translations["en"]] || key;
    
    if (params) {
      return Object.entries(params).reduce((result, [param, value]) => {
        return result.replace(`{${param}}`, String(value));
      }, translation);
    }
    
    return translation;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
